var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
export class TreatmentProgressEntryDto {
    abbreviation;
    code;
    /**
     * The Heilmittelkatalog option the units were prescribed as (GKV, #1425) —
     * `MLD-45 + anschließender Kompressionsbandagierung` where the concept only says
     * `MLD`. Null where the Verordnung records none (PKV, Selbstzahler, older plans).
     */
    optionName;
    sequencesInPlan;
    authorizedUnitCount;
}
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentProgressEntryDto.prototype, "abbreviation", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], TreatmentProgressEntryDto.prototype, "code", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], TreatmentProgressEntryDto.prototype, "optionName", void 0);
__decorate([
    IsArray(),
    IsNumber({}, { each: true }),
    Expose(),
    __metadata("design:type", Array)
], TreatmentProgressEntryDto.prototype, "sequencesInPlan", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], TreatmentProgressEntryDto.prototype, "authorizedUnitCount", void 0);
export class TreatmentProgressDto {
    entries;
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => TreatmentProgressEntryDto),
    Expose(),
    __metadata("design:type", Array)
], TreatmentProgressDto.prototype, "entries", void 0);
//# sourceMappingURL=treatment-progress.dto.js.map